export default {
    name: "date_relative",
    definition: {
        init: function () {
            this.jsonInit({
                "message0": 'Get relative date %1 to date %2',
                "args0": [
                    {
                        "type": "input_value",
                        "name": "EXPRESSION",
                        "check": "String"
                    },
                    {
                        "type": "input_value",
                        "name": "DATE",
                        "check": "Date"
                    }
                ],
                "inputsInline": true,
                "output": ["String", "Date"],
                "colour": 4.5,
                "tooltip": "Get part of date",
                "helpUrl": "http://www.w3schools.com/jsref/jsref_length_string.asp"
            });
        }
    },
    codeGenerator: (blocklyInstance) => function (block) {
        const date = blocklyInstance.JavaScript.valueToCode(block, "DATE", blocklyInstance.JavaScript.ORDER_ATOMIC);
        const expression = blocklyInstance.JavaScript.valueToCode(block, "EXPRESSION", blocklyInstance.JavaScript.ORDER_ATOMIC);

        return [`getRelativeDate(${date}, ${expression})`, blocklyInstance.JavaScript.ORDER_NONE];
    }
}